import { render } from "./DisplayText.vue?vue&type=template&id=866ae456&scoped=true"
import script from "./DisplayText.vue?vue&type=script&lang=js"
export * from "./DisplayText.vue?vue&type=script&lang=js"

import "./DisplayText.vue?vue&type=style&index=0&id=866ae456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866ae456"],['__file',"src/components/shared/DisplayText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "866ae456"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('866ae456', __exports__)) {
    api.reload('866ae456', __exports__)
  }
  
  module.hot.accept("./DisplayText.vue?vue&type=template&id=866ae456&scoped=true", () => {
    api.rerender('866ae456', render)
  })

}


export default __exports__